import { render, staticRenderFns } from "./PcPage.vue?vue&type=template&id=7dc7070e&scoped=true"
import script from "./PcPage.vue?vue&type=script&lang=ts"
export * from "./PcPage.vue?vue&type=script&lang=ts"
import style0 from "./PcPage.vue?vue&type=style&index=0&id=7dc7070e&prod&lang=less&scoped=true"
import style1 from "./PcPage.vue?vue&type=style&index=1&id=7dc7070e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc7070e",
  null
  
)

export default component.exports